/**
 * File: ant-video-child.js
 * Created Date: Mon Mar 11 2019
 * Author: Coffee
 * Description: 互动视频的子页面接入类，负责提供接入以及数据返回
 * 
 * Copyright (c) 2019 HuluGames
 */

import log from './log';
import Postmate from 'postmate';
// Postmate.debug = true;

const VIDEO_FRAME_ID = 'myVideoFrame';

// this._model.play = () => this._instance.play();
// this._model.seek = time => this._instance.seek(time);
// this._model.pause = () => this._instance.pause();
// this._model.toggleFullScreen = () => this._instance.toggleFullScreen();        
// this._model.resetTask = () => this._instance.resetTask();

const CallAPI = [
    'play',
    'seek',
    'pause',
    // 'toggleFullScreen',
    'resetTask',
    'setAntEventCorrect'
];

class AntVideoChild {
    constructor (frameId) {
        this._parent = null;
        this._h5p = null;
        this._instance = null;
        this._model = {};
        this._initialize(frameId);
    }

    _initModel () {
        this._model = {};
        this._model.model = () => {
            const ret = [];
            for (const k in this._model) {
                if (this._model.hasOwnProperty(k)) {
                    let callApi = false;
                    if (CallAPI.indexOf(k) !== -1) {
                        callApi = true;
                    }
                    ret.push({key: k, type: typeof this._model[k], callAble: callApi});
                }
            }
            return ret;
        };

        this._model.width = () => document.getElementById(VIDEO_FRAME_ID).width;
        this._model.height = () => document.getElementById(VIDEO_FRAME_ID).height;
        this._model.getAnsweredTotal = () => this._instance.getAnsweredTotal();
        this._model.getCurrentState = () => this._instance._getCurrentState();
        this._model.hasMainSummary = () => this._instance.hasMainSummary();
        this._model.getScore = () => this._instance.getScore();
        this._model.getMaxScore = () => this._instance.getMaxScore();
        this._model.isFullscreen = () => this._h5p.isFullscreen;

        // this._model.play = () => this._instance.play();
        // this._model.seek = time => this._instance.seek(time);
        // this._model.pause = () => this._instance.pause();
        // this._model.toggleFullScreen = () => this._instance.toggleFullScreen();        
        // this._model.resetTask = () => this._instance.resetTask();

        for (let i = 0; i < CallAPI.length; ++i) {
            const apiName = CallAPI[i]
            if (this._instance[apiName] && typeof this._instance[apiName] === 'function') {
                this._model[apiName] = (data) => this._instance[apiName](data);
            }
        }
    }

    _initialize (frameId) {
        const videoFrame = document.getElementById(frameId);
        const contentWin = videoFrame.contentWindow;
        this._h5p = contentWin.H5P;
        this._instance = this._h5p.instances[0];

        this._initModel();

        const handshake = new Postmate.Model(this._model);
        handshake.then(parent => {
            this._parent = parent;

            // add event listener to h5p then
            this._h5p.externalDispatcher.on('xAPI', event => {
                this._fireEvent('xAPI', event.data);
            });
            this._h5p.externalDispatcher.on('ant-event', event => {
                this._fireEvent('ant-event', event.data);
            }); 
            
            this._instance.on('video-play', event => {
                this._fireEvent('video-play', event.data);
            })

            this._instance.on('video-pause', event => {
                this._fireEvent('video-pause', event.data);
            })
        });
    }

    _fireEvent (type, event) {
        if (this._parent) {
            this._parent.emit(type, event);
        }
    }
}

export default AntVideoChild;
